import React from 'react';

import ChatPerson from 'assets/images/notFounds/chatPerson.svg';
import {useNavigate} from 'react-router-dom';
interface HeaderInfoProps {
  name: string;
  imgUrl?: string;
}
const HeaderInfo = ({name, imgUrl}: HeaderInfoProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex gap-3 items-center ">
      <div className="flex h-full items-center font-normal">
        <button
          onClick={() => {
            navigate(-1);
          }}
          className="icon-arrow_left text-[19px]"
        />
      </div>
      <div className="flex w-[38px] h-[38px]">
        <img
          className="rounded-full"
          src={ChatPerson}
          width={38}
          height={38}
          alt="profile"
        />
      </div>
      <div className="">
        <span className="font-normal text-[14px] leading-[24px]">{name}</span>
      </div>
    </div>
  );
};

export default HeaderInfo;
